export const HEADER_SWITCH = {
  init: function () {
    const headerSwitch = document.querySelector('.l-header__switch')
    if (!headerSwitch) return

    let lastScroll = 0

    window.addEventListener('scroll', () => {
      // メニュー開いている時は動かさない
      if (document.body.classList.contains('is-gnav-open')) return

      const currentScroll = window.pageYOffset

      if (currentScroll > lastScroll && currentScroll > 100) {
        // 下スクロール
        headerSwitch.classList.add('is-hide')
      } else {
        // 上スクロール
        headerSwitch.classList.remove('is-hide')
      }

      lastScroll = currentScroll
    })
  },
}
